import { FC, useCallback, useEffect } from 'react';

import leapifyLogo from 'assets/images/Leapify-Logo.svg';
import { MailIcon } from 'ui/components/icon';
import { Link } from 'react-router-dom';
import { PublicWrapper } from 'pages/public/containers';
import { Button } from 'ui/components/common';
import { useGetProfile } from 'modules/account/settings/hooks';
import { useRefreshTokenV2, useResendOtp } from 'pages/private/hooks';
import { cn, useProfile } from 'utils/helpers';

const VerifyEmail: FC = () => {
  const { data } = useGetProfile();
  const { setProfile } = useProfile();
  const { mutate: resendOtp } = useResendOtp();
  const { data: token, isLoading: isTokenLoading } = useRefreshTokenV2();

  useEffect(() => {
    if (!isTokenLoading) {
      if (token?._isEmailAddressVerified) {
        setProfile({ profile: token });
        window.location.reload();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTokenLoading, token]);

  const handleResendVerification = useCallback(() => {
    if (data?._id) resendOtp(data?._id);
  }, [data?._id, resendOtp]);

  return (
    <PublicWrapper
      className={cn(
        'flex items-center md:justify-center flex-col',
        'px-6 py-[22px] md:py-0',
      )}
    >
      <div
        className={cn(
          'w-full max-w-[600px] p-8 rounded-[6px]',
          'bg-fill-tertiary shadow-custom text-center',
        )}
      >
        <img
          alt="Leapify Logo"
          className="w-[137px] mb-16 inline-block mx-auto"
          src={leapifyLogo}
        />
        <div className="w-[75px] m-auto">
          <MailIcon className="text-primary-base" />
        </div>
        <div className="pb-8 mb-8 mt-7 border-b border-b-separator-primary">
          <h3 className="text-secondary text-[22px] font-semibold mb-3">
            Check your email
          </h3>
          <div>
            <p className="text-[14px] font-normal">
              We’ve sent a verification link to{' '}
              <span className="font-semibold">{data?.emailAddress}</span>.
            </p>
            <p className="text-[14px] font-normal">
              Please click the link to verify your account and get started.
            </p>
          </div>
        </div>
        <div className="mb-6">
          <p className="text-[12px] font-normal text-secondary-light">
            Didn’t receive the email? Check your spam folder
          </p>
          <p className="text-[12px] font-normal text-secondary-light">or</p>
          <Button
            onClick={handleResendVerification}
            size="sm"
            label="Resend Verification Link"
            intent="link"
            className="mx-auto p-2"
          />
        </div>
        <Link
          to="/logout"
          className="text-primary-base p-2.5 text-center text-xs"
        >
          Back to login
        </Link>
      </div>
    </PublicWrapper>
  );
};

export default VerifyEmail;
